import { Link } from "@inertiajs/react"
import { ChevronRight } from "lucide-react"

interface ChecklistItem {
  label: string
  link: string
}

interface ProfileCompletionProps {
  percentage: number
  checklist: ChecklistItem[]
}

function getProgressColor(percentage: number): string {
  if (percentage > 80) return "#b0ee45"
  if (percentage >= 40) return "#ff9119"
  return "#ef4444"
}

export default function ProfileCompletion({
  percentage,
  checklist,
}: ProfileCompletionProps) {
  if (percentage >= 100) return null

  const color = getProgressColor(percentage)
  const radius = 40
  const circumference = 2 * Math.PI * radius
  const offset = circumference - (percentage / 100) * circumference

  return (
    <div className="border-border bg-card overflow-hidden rounded-lg border">
      <div className="flex items-center gap-4 p-4 pb-3">
        <div className="relative h-16 w-16 flex-shrink-0">
          <svg className="h-16 w-16 -rotate-90" viewBox="0 0 100 100">
            <circle
              cx="50"
              cy="50"
              r={radius}
              fill="none"
              stroke="currentColor"
              strokeWidth="10"
              className="text-muted/30"
            />
            <circle
              data-testid="progress-ring-circle"
              cx="50"
              cy="50"
              r={radius}
              fill="none"
              stroke={color}
              strokeWidth="10"
              strokeLinecap="round"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
            />
          </svg>
          <span className="absolute inset-0 flex items-center justify-center text-sm font-bold text-white">
            {percentage}%
          </span>
        </div>
        <div>
          <h3 className="text-sm font-semibold text-white">
            Completá tu perfil
          </h3>
          <p className="text-muted-foreground mt-0.5 text-xs">
            {checklist.length}{" "}
            {checklist.length === 1 ? "paso restante" : "pasos restantes"}
          </p>
        </div>
      </div>

      <div className="border-border border-t">
        {checklist.map((item, index) => (
          <Link
            key={item.label}
            href={item.link}
            className={`group flex items-center justify-between px-4 py-2.5 transition-colors hover:bg-white/5 ${
              index < checklist.length - 1 ? "border-border border-b" : ""
            }`}
          >
            <span className="text-sm text-white/80 group-hover:text-white">
              {item.label}
            </span>
            <ChevronRight className="text-muted-foreground h-4 w-4 shrink-0 group-hover:text-white" />
          </Link>
        ))}
      </div>
    </div>
  )
}
